<!-- == == -->
<section class="property-choose-card-sec">
  <div class="container-fluid">
    <div class="row g-3">
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Resorts</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Resorts</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Resorts</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Resorts</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="gr-card">
          <div class="gr-badge">Hotel</div>

          <!-- Galleria Integration -->
          <p-galleria
            [value]="images"
            [numVisible]="5"
            [circular]="true"
            [showItemNavigators]="true"
            [showThumbnails]="false"
            [responsiveOptions]="responsiveOptions"
            [containerStyle]="{ 'max-width': '100%' }"
          >
            <ng-template let-item pTemplate="item">
              <div class="gr-image"><img [src]="images" [alt]="item.alt" /></div>
            </ng-template>
          </p-galleria>

          <div class="gr-status">Out Of Market</div>
          <div class="gr-content">
            <h2 class="gr-title">Golden Ridge</h2>
            <div class="gr-content-wrap">
              <div class="gr-stats">
                <div class="gr-stats-item"><i class="fas fa-bed"></i> 150 occupied</div>
                <div class="gr-stats-item"><i class="fas fa-door-open"></i> 50 vacant</div>
                <div class="gr-stats-item"><i class="fas fa-calendar-check"></i> 50 booked</div>
              </div>
              <hr class="gr-devider" />
              <div class="gr-location">
                <i class="fas fa-location-dot"></i> <span> 8 Ridgewood St Dorchester, Boston, MA 02122</span>
              </div>
              <a href="#" class="gr-button">Go To Dashboard</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- == == -->
